<template>
    <div class="email_modal" v-if="showPopup">
        <div class="model_block" >
            <div class="email_body">
                <div v-if="!success">
                    <div class="title_block">
                        <div>
                            <h3 class="mb-3 font-active">Save Big: Get $50 Off* Your Purchase</h3>
                            <p>Subscribe now and receive the Special Promo Code!</p>
                        </div>
                        <span class="upto_medium" @click="hideModal">
                            <SvgHeaderSvg :type="'close'" class="largesvg"/>
                        </span>
                    </div>
                    <form action="" @submit.prevent="Submit()">
                        <div class="pb-3 column">
                            <CommonBaseInput name="your_name" :required="true" :id="'name'" mode=""
                                v-model="formData.name" placeholder="Your Name" type="text"
                                @input="(text) => handleInput('name', text)" />
                            <span v-if="errorMessage.name" class="error-msg">{{ errorMessage.name.join(" ") }}</span>
                        </div>
                        <div class="pb-4 column">
                            <CommonBaseInput name="email" :required="true" :id="''" mode="" v-model="formData.email"
                                placeholder="Email Id" type="email" @input="(text) => handleInput('email', text)" />
                            <span v-if="errorMessage.email" class="error-msg">{{ errorMessage.email.join(" ") }}</span>
                        </div>
                        <div class="d-flex gap-2">
                            <CommonBasePrimary type="button" class="decline-btn flex-1" @click="hideModal">Decline</CommonBasePrimary>
                            <CommonBasePrimary disabled v-if="showLoader" class="flex-1">please wait...</CommonBasePrimary>
                            <CommonBasePrimary v-else type="submit" class="flex-1">sign me up</CommonBasePrimary>
                        </div>
                        <!-- <p class="success mb-0" v-if="success">{{ success }}</p> -->
                    </form>
                    <div class="title_block mt-2">
                        <p class="mb-0">*Minimum purchase value of $1000. Cannot be clubbed with another offer.</p>
                    </div>
                </div>
                <div v-else class="success">
                    <div class="title_block">
                        <div>
                            <h3 class="mb-3 font-active">Congratulations!</h3>
                            <p>You’ve unlocked a Special Promo Code for your purchase.</p>
                            <p>Use this code during checkout:</p>
                        </div>
                        <span class="upto_medium" @click="hideModal">
                            <SvgHeaderSvg :type="'close'" class="largesvg"/>
                        </span>
                    </div>
                    <div class="promoCode">
                        <h6>Promo Code</h6>
                        <div class="promo_flex">
                            <div class="promo_text font-active" id="promo_text">
                                {{ copyText }}
                            </div>
                            <div class="copy_btn" @click="copyToClipboard">
                                <span v-if="isCopied">Copied!</span>
                                <img src="@/assets/copy.svg" alt="copy to clipboard">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { popupStore } from '@/stores/popup/popup';
const store = popupStore()
const showPopup = ref(false)
const showLoader = ref(false)
const formData = ref({
    name: '',
    email: ''
})

const success = ref(false)
const errorMessage = ref({})
const copyText = ref('FD50')
const isCopied = ref(false)
const module = ref('subscribe')

const copyToClipboard = () => {
    const textarea = document.createElement('textarea');
    textarea.value = copyText.value;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    isCopied.value = true
}

const handleInput = (key, value) => {
    formData.value[key] = value
}

const showModal = () => {
    // this.$refs['my-modal'].show()
}

const hideModal = () => {
    showPopup.value = false
}

const hideMsg = () => {
    setTimeout(() => {
        success.value = false
    }, 3000);
}

const Submit = async () => {
    try {
        showLoader.value = true
        const res = await $fetch(useCountryPath('/subscribe/from-popup'), {
            method: 'POST',
            body: formData.value
        })

        if (res.success) {
            // message = false;
            errorMessage.value = false;
            showLoader.value = false
            success.value = res.message
        }

    } catch (error) {
        showLoader.value = false
        if (error.response !== undefined && error.response.status === 422) {
            errorMessage.value = error?.response?._data?.errors
            // showLoader.value = false
            return;
        }
    }

}


onMounted(async () => {

    const status = await store.getPopupFlag(module.value)
    if (!status) {
        setTimeout(() => { showPopup.value = true }, 7000)
        store.setPopupFlag(module.value)
    }
})

</script>

<style scoped>
.decline-btn{
    color: #000;
    background: #fff !important;
    border: 1px solid #000;
}
button {
    border-radius: 4px;
}
.largesvg {
    transform: scale(1.3);
}
p.success {
    text-align: center;
    margin-top: 5px;
}

video {
    max-width: 100%;
    height: auto;
}

.error {
    color: rgb(255, 0, 0);
}

.copy_btn span {
    font-size: 12px;
    font-weight: 500;
}

.model_block {
    width: 90%;
    margin: 0 auto;
    background: #fff;
    border-radius: 5px;
}

.modal_img img {
    border-radius: 4px 0 0 4px;
}

.email_body {
    padding: 26px;
    position: fixed;
    bottom: 30px;
    left: 30px;
    background: #fff;
    width: 350px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.2);
    z-index: 999;
    border-radius: 8px;
}

.title_block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.title_block h3 {
    font-size: 20px;
    text-align: left;
}

.title_block p {
    font-size: 14px;
    color: #6a6161;
}

.title_block span {
    cursor: pointer;
}

span.below_medium {
    display: none;
}

.promo_flex {
    border: 1px dashed #c4c4c4;
    border-radius: 5px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

h6 {
    color: #353535;
    font-size: 14px;
    font-weight: 800;
}

.promo_text {
    color: var(--green);
    font-size: 16px;
    letter-spacing: 0.5px;
}

.copy_btn {
    cursor: pointer;
    height: 27px;
}

@media(max-width: 1200px) {
    .modal_img img {

        width: 100%;
    }
}

@media(max-width: 1200px) {
    .model_block img {
        height: 100%;
        object-fit: cover;
    }

    .modal_img {
        position: relative;
        height: 100%;
    }

    .model_block {
        width: 100%;
    }

    .title_block h3 {
        font-size: 24px;
    }

    .email_body {
        padding: 7%;
        /* border-radius: 0 0 5px 5px; */
    }

    .email_body {
        padding: 20px;
        background: #fff;
    }

    .col-md-12 {
        padding: 0 !important;
    }

    .modal_img img {
        border-radius: 5px 5px 0 0;
    }

    .title_block p {
        font-size: 14px;
    }
}

@media(max-width: 992px) {
    .modal_img span.below_medium {
        position: absolute;
        top: 6px;
        right: 20px;
        display: block;
    }

}

@media(max-width: 600px) {
    .email_body {
        left: 50%;

        transform: translate(-50%, 0);
        z-index: 99999;
    }

    .modal_img span.below_medium {
        top: 0px;
        right: 8px;
    }

    .model_block {
        width: 85%;
        margin: 0 auto;
    }

    .title_block h3 {
        font-size: 20px;
        margin-bottom: 7px !important;
    }

    .title_block p {
        font-size: 14px;
    }
}
</style>
